var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31 16v-4h10v4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51 25v31c0 2.2091-1.7909 4-4 4h-22c-2.2091 0-4-1.7909-4-4v-31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17 16h38v4h-38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41 28.25v26.75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m31 28.25v26.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.232b50fcefdfe29ac9c47b0b79334df8.svg";
export { ForwardRef as ReactComponent };